import type { SupraSystemSubscriptionDoc } from '@bb/domain/dist/schemas';
import type { UserWithPopulatedOrg } from '@bb/users';
import axios from 'axios';

export type IGetSubscriptionByKeySerialNumber = {
  requestOwnerMappingId: string;
  user: UserWithPopulatedOrg;
  subscription: SupraSystemSubscriptionDoc;
};

const getSubscriptionByKeySerialNumber = async (
  keySerialNumber: number,
  pin: string,
) => {
  const { data } = await axios.get<IGetSubscriptionByKeySerialNumber>(
    `/supra/subscription_by_sn/${keySerialNumber}?pin=${pin}`,
  );

  return data;
};

export default getSubscriptionByKeySerialNumber;
